/*
 * @Author: Teemo Ding
 * @Date: 2022-03-02 15:09:23
 * @LastEditTime: 2022-06-10 09:02:34
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/CommunicationChannelsPriority/index.tsx
 */
import DroppableTable from '@/src/components/DroppableTable/DroppableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { Checkbox } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { priorityColumns } from '../config';
import css from '../css.module.less';

const CommunicationChannelsPriority = ({
  priorities,
  changePriorities,
  changeSimultaneous,
  simultaneous,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      // containerClassName={css.invoiceFormat}
      title={getI18n(
        'salesChannelCommunication.index.communicationChannelsPriority',
      )}>
      <Checkbox
        className={css.simultaneous}
        checked={simultaneous}
        onChange={changeSimultaneous}
        disabled={disableEdit}>
        {getI18n(
          'salesChannelCommunication.index.communicationChannelsPriorityCheckbox',
        )}
      </Checkbox>
      <div>
        <h3 className={css.tableTitle}>
          {getI18n(
            'salesChannelCommunication.index.communicationchannelprioritysetting',
          )}
        </h3>
        <DroppableTable
          dataSource={priorities || []}
          id='taxRules'
          rowKey={(record) => record}
          onTableChange={changePriorities}
          pagination={false}
          columns={priorityColumns({ getI18n })}
          hideAllDragHandlers={disableEdit}
        />
      </div>
    </SectionWrapper>
  );
};

export default CommunicationChannelsPriority;
